module.exports = __webpack_public_path__ + "assets/img/track-bottom-bg-light.6a12926b.png";